import { subWeeks, startOfWeek, endOfWeek, addWeeks, format } from "date-fns";

const lastWeekToCurrent = (value) => {
  const currentDate = new Date();
  const startDate = startOfWeek(subWeeks(currentDate, Number(value) - 1), {
    weekStartsOn: 0,
  });

  const endDate = endOfWeek(currentDate, { weekStartsOn: 0 });

  const formattedStartDate = format(startDate, "dd/MM/yyyy");
  const formattedEndDate = format(endDate, "dd/MM/yyyy");
  const dates = { formattedStartDate, formattedEndDate };
  return dates;
};

const currentWeekToNextWeek = (value) => {
  const currentDate = new Date();
  const startDate = startOfWeek(currentDate, { weekStartsOn: 0 }); // Week starts on Sunday
  const endDate = endOfWeek(addWeeks(currentDate, Number(value) - 1), {
    weekStartsOn: 0,
  }); // Week ends on Saturday of Nth week
  const formattedStartDate = format(startDate, "dd/MM/yyyy");
  const formattedEndDate = format(endDate, "dd/MM/yyyy");
  const dates = { formattedStartDate, formattedEndDate };
  return dates;
};

const fromThisWeekToThisWeek = (value) => {
  const currentDate = new Date();

  let startDate;
  let endDate;

  if (value === "Last Week") {
    startDate = startOfWeek(subWeeks(currentDate, 1), { weekStartsOn: 0 }); // Subtract 1 week
    endDate = endOfWeek(subWeeks(currentDate, 1), { weekStartsOn: 0 }); // Same week as start
  } else if (value === "This Week") {
    startDate = startOfWeek(currentDate, { weekStartsOn: 0 }); // Current week's start
    endDate = endOfWeek(currentDate, { weekStartsOn: 0 }); // Current week's end
  } else if (value === "Next Week") {
    startDate = startOfWeek(addWeeks(currentDate, 1), { weekStartsOn: 0 }); // Add 1 week
    endDate = endOfWeek(addWeeks(currentDate, 1), { weekStartsOn: 0 }); // Same week as start
  } else {
    console.error(
      "Invalid value, please use 'Last Week', 'This Week', or 'Next Week'"
    );
  }

  if (startDate && endDate) {
    const formattedStartDate = format(startDate, "dd/MM/yyyy");
    const formattedEndDate = format(endDate, "dd/MM/yyyy");
    return { formattedStartDate, formattedEndDate };
  } else {
    // console.log("start and end date is undefined");
  }
};

export { lastWeekToCurrent, currentWeekToNextWeek, fromThisWeekToThisWeek };
